export default "__VITE_ASSET__a25be231__"